<script setup lang="ts">
/*
* Компонент AdverseEventsLayout - основной лейаут для работы с нежелательными явлениями
*
* Функционал:
* - Загрузка и управление данными о нежелательных явлениях
* - Интеграция с API через apiStore
* - Управление состоянием загрузки через feedbackStore
* - Серверная фильтрация данных
* - Композиция дочерних компонентов:
*   * Панель отделений и статистики
*   * Фильтры таблицы инцидентов
*   * Таблица инцидентов
*
* Особенности:
* - Автоматическая загрузка данных при монтировании
* - Реакция на изменение фильтров (в server-режиме)
* - Централизованное управление состоянием через хранилища
*/

import { onMounted } from 'vue'
import { useApiStore } from '@/modules/apiStore/stores/apiStore'

// Импорты компонентов
import IncidentsTable from '@/components/adverseEvents/IncidentsTable.vue'

// Инициализация хранилищ
const apiStore = useApiStore() // Хранилище API-запросов и данных

/**
 * Хук монтирования компонента
 *
 * Выполняет:
 * 1. Загружает список НС с применёнными фильтрами через apiStore.
 *
 * Подписка на realtime больше здесь не поднимается: общий диспетчер
 * в src/utils/subscribeHelpers.ts подписан на единый канал user:user#sub
 * после логина и маршрутизирует adverse_event_* в apiStore.applyAdverseEventRealtime.
 */
onMounted(async () => {
  await apiStore.fetchFilteredAdverseEvents()
})
</script>

<template>
  <IncidentsTable />
  <RouterView />
</template>
